var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"i-option"},[_c('a',[_c('span',{class:_vm.icon}),_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title)),_c('span',[_vm._v(_vm._s(_vm.desc))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }